import { render, staticRenderFns } from "./buyer.vue?vue&type=template&id=1a3d1045&scoped=true"
import script from "./buyer.vue?vue&type=script&lang=js"
export * from "./buyer.vue?vue&type=script&lang=js"
import style0 from "./buyer.vue?vue&type=style&index=0&id=1a3d1045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3d1045",
  null
  
)

export default component.exports